import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PageHeaderComponent } from '@nucleus/ui-base';

@Component({
    selector: 'app-terms',
    imports: [MatDialogModule, MatIconModule, MatButtonModule, MatTooltipModule, PageHeaderComponent],
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.css'
})
export class TermsComponent {}
